import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../utils/constant";
import { toastr } from "react-redux-toastr";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const AssetsBasedRisk = () => {
  const { ip } = useParams();
  const [vulnerabilities, setVulnerabilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [severity, setSeverity] = useState("");
  const [isModal, setModal] = useState("");
  const [selectedVuln, setSelectedVuln] = useState({});
  const [isScanning, setIsScanning] = useState(false);
  const [scanStatus, setScanStatus] = useState({});
  const [lastScanned, setLastScanned] = useState({});
  const [stats, setStats] = useState({});

  // Snooze functionality states
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [isModalTwo, setModalTwo] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [name, setName] = useState("");
  const [lookalikeIssueId, setLookalikeIssueId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [category, setCategory] = useState("all");

  const { orgId } = useParams();
  const auth = useSelector((state) => state?.auth?.user);
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });

  const vendorId = sessionStorage.getItem('vendorId');
  const vendorName = sessionStorage.getItem('vendorName');
  const clientName = sessionStorage.getItem('vendorName') || JSON.parse(localStorage.getItem("OrgName") || "{}");

  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  useEffect(() => {
    if (id && ip) {
      fetchAssetVulnerabilities();
    }
  }, [id, page, search, severity, limit, ip, category]);

  const fetchAssetVulnerabilities = async () => {
    try {
      setLoading(true);
      const session = localStorage.getItem("session");

      // Build query parameters
      const params = new URLSearchParams();
      if (category && category !== "all") {
        params.append("category", category);
      }
      // Add pagination parameters
      params.append("page", page);
      params.append("limit", limit);
      // Add search parameter if provided
      if (search) {
        params.append("search", search);
      }
      // Add severity parameter if provided
      if (severity) {
        params.append("severity", severity);
      }

      const response = await axios.get(
        `${API_URL}/organisations/${id}/assets/${ip}/vulns?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${session}` }
        }
      );

      const data = response.data?.data;
      if (data) {
        setVulnerabilities(data.vulnerabilities || []);
        setScanStatus(data.scanStatus || {});
        setLastScanned(data.lastScanned || {});
        setStats(data.stats || {});
        
        // Use pagination info from backend
        if (data.pagination) {
          setTotalItems(data.pagination.total || 0);
          setPage(data.pagination.page || 1);
        } else {
          setTotalItems(data.vulnerabilities?.length || 0);
        }
      }

    } catch (error) {
      // console.error removed
    } finally {
      setLoading(false);
    }
  };

  // Remove client-side filtering since backend handles it
  // useEffect(() => {
  //   if (allVulnerabilities.length > 0) {
  //     // Filter by search and severity only (category is handled by API)
  //     let filteredData = allVulnerabilities;

  //     if (search) {
  //       filteredData = filteredData.filter(vuln =>
  //         vuln.name?.toLowerCase().includes(search.toLowerCase()) ||
  //         vuln.description?.toLowerCase().includes(search.toLowerCase()) ||
  //         vuln.cveId?.toLowerCase().includes(search.toLowerCase())
  //       );
  //     }

  //     if (severity) {
  //       filteredData = filteredData.filter(vuln =>
  //         vuln.severity?.toLowerCase() === severity.toLowerCase()
  //       );
  //     }

  //     // Update total items after filtering
  //     setTotalItems(filteredData.length);

  //     // Apply pagination
  //     const startIndex = (page - 1) * limit;
  //     const endIndex = startIndex + limit;
  //     setVulnerabilities(filteredData.slice(startIndex, endIndex));
  //   }
  // }, [allVulnerabilities, page, limit, search, severity]);

  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    clearTimeout(handleSearchChange.timeoutId);
    handleSearchChange.timeoutId = setTimeout(() => {
      setSearch(inputValue);
      setPage(1); // Reset to first page on search
      // The useEffect will trigger fetchAssetVulnerabilities with new search value
    }, 1000);
  };

  const handlePageSizeChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setPage(1); // Reset to first page when changing page size
    // The useEffect will trigger fetchAssetVulnerabilities with new limit
  };

  const editModal = (vulnerability) => {
    setSelectedVuln(vulnerability);
    setModal("Form Wizard modal");
  };

  // Snooze functionality
  const handleVulnerabilityAction = async (scanIds, actionType, note = "", duration = "forever", isUnsnooze = false) => {
    try {
      setLoading(true);
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

      const endpoint = isUnsnooze
        ? `${API_URL}/active-scan/${id}/ActiveVulnsAndNuclie/action`
        : `${API_URL}/active-scan/${id}/ActiveVulnsAndNuclie/action`;

      const data = {
        action: isUnsnooze ? "resetAction" : actionType,
        recordIds: scanIds,
        actionNote: note,
        for: duration
      };

      const response = await axios.post(endpoint, data);

      toastr.success(
        response.data.message || "Success",
        isUnsnooze ? "Items have been unsnoozed" : "Action applied successfully"
      );

      fetchAssetVulnerabilities();
      setSelectedIds([]);
      setMultiCheckTrue(false);
    } catch (error) {
      // console.error removed
      toastr.error("Error", isUnsnooze ? "Failed to unsnooze items" : "Failed to apply action");
      setLoading(false);
    }
  };

  const handleSnoozeAction = (scanIds, actionType, note = "", duration = "forever") =>
    handleVulnerabilityAction(scanIds, actionType, note, duration, false);

  const unsnooze = (ids) =>
    handleVulnerabilityAction(ids, "resetAction", "", "forever", true);

  // Handle multi-selection check
  const multicheck = (data) => {
    const allIds = data?.map((item) => item?._id);
    
    // Check if all items are currently selected
    const allSelected = allIds.every(id => selectedIds.includes(id));
    
    if (allSelected) {
      // If all are selected, deselect all
      setSelectedIds([]);
      setMultiCheckTrue(false);
    } else {
      // If not all are selected, select all
      setSelectedIds(allIds);
      setMultiCheckTrue(true);
    }
  };

  // Handle single item selection
  const singleClick = (id) => {
    setSelectedIds((prevSelectedIds) => {
      const newSelectedIds = prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((selectedId) => selectedId !== id)
        : [...prevSelectedIds, id];
      
      // Update multiCheckTrue based on whether all visible items are selected
      const allVisible = vulnerabilities.map(vuln => vuln?._id);
      setMultiCheckTrue(allVisible.length > 0 && allVisible.every(visibleId => newSelectedIds.includes(visibleId)));
      
      return newSelectedIds;
    });
  };

  // Handle snooze button click
  const snooze = (_id, event, name) => {
    if (event === "markAsRemidiated") {
      handleSnoozeAction(selectedIds.length === 0 ? [_id] : selectedIds, "markAsRemidiated");
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
      setMultiCheckTrue(false);
    } else if (event === "riskAccepted" || event === "markAsFalsePositive") {
      setAction(event);
      setModalTwo("Form Wizard modal two");
      if (_id) {
        setLookalikeIssueId([_id]);
        setName(name);
      }
    }
  };

  // Submit snooze with comments
  const submitSnooze = () => {
    handleSnoozeAction(
      selectedIds.length === 0 ? lookalikeIssueId : selectedIds,
      action,
      actionNote,
      forValue
    );
    setModalTwo("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
    setMultiCheckTrue(false);
  };

  const handleRescan = async () => {
    try {
      setIsScanning(true);
      const session = localStorage.getItem("session");
      const response = await axios.post(
        `${API_URL}/create-active-scan/${id}`,
        {
          targets: [ip],
          targetType: "assets"
        },
        {
          headers: { Authorization: `Bearer ${session}` }
        }
      );

      if (response.data?.message) {
        toastr.success("Success", response.data.message);
      }

      // Refresh the vulnerabilities list after scan
      fetchAssetVulnerabilities();
    } catch (error) {
      if (error.response?.data?.message) {
        toastr.error("Error", error.response.data.message);
      } else {
        toastr.error("Error", "Failed to initiate rescan. Please try again.");
      }
    } finally {
      setIsScanning(false);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage />
        <ReactTooltip className="reactTooltipClass" />
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Asset Vulnerabilities</h1>
              <h4 className="text-muted mt-2">Target: {ip}</h4>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ?
                      <Link to="/vendor" onClick={() => sessionStorage.clear()}>
                        Vendor Assessment
                      </Link>
                      :
                      <Link to="/" className="welcome-textSmall">
                        Home
                      </Link>
                    }
                  </li>
                  {vendorName && (
                    <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
                      <Link to={`/dashboard/vendor/${vendorId}`}>{vendorName}</Link>
                    </li>
                  )}
                  <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
                    <Link to="/consolidated-assets">Assets</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
                    Asset Vulnerabilities
                  </li>
                </ol>
                <br />
              </nav>
            </div>
          </div>
        </div>

        {loading && <div className="card border-success"><ScanMessage /></div>}

        {/* Scan Status and Stats */}
        <div className="row clearfix mb-4">
          <div className="col-lg-12 col-md-12">
            <div className="card">
              <div className="header">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <h4 className="mb-0">Scan Status</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      className="btn btn-primary"
                      onClick={handleRescan}
                      disabled={isScanning}
                    >
                      {isScanning ? (
                        <>
                          <i className="fa fa-spinner fa-spin mr-1"></i>
                          Scanning...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh mr-1"></i>
                          Rescan Asset
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="alert alert-info">
                      <strong>Last Scan:</strong><br />
                      Web Scan: {lastScanned.nuclei ? new Date(lastScanned.nuclei).toLocaleString() : 'N/A'}<br />
                      Infrastructure Scan: {lastScanned.active ? new Date(lastScanned.active).toLocaleString() : 'N/A'}
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12">
                    <div className="card mb-0">
                      <div className="header">
                        <h5 className="mb-0">Vulnerability Statistics</h5>
                      </div>
                      <div className="body">
                        <div className="row">
                          <div className="col-md-2 col-sm-4 col-6 mb-3">
                            <div className="card border">
                              <div className="body text-center p-3">
                                <h4 className="mb-1">{stats.total || 0}</h4>
                                <small className="text-muted">Total</small>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-4 col-6 mb-3">
                            <div className="card border" style={{ borderLeft: '4px solid #dc3545' }}>
                              <div className="body text-center p-3">
                                <h4 className="mb-1">{stats.critical || 0}</h4>
                                <small className="text-muted">Critical</small>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-4 col-6 mb-3">
                            <div className="card border" style={{ borderLeft: '4px solid #ff9800' }}>
                              <div className="body text-center p-3">
                                <h4 className="mb-1">{stats.high || 0}</h4>
                                <small className="text-muted">High</small>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-4 col-6 mb-3">
                            <div className="card border" style={{ borderLeft: '4px solid #ffc107' }}>
                              <div className="body text-center p-3">
                                <h4 className="mb-1">{stats.medium || 0}</h4>
                                <small className="text-muted">Medium</small>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-4 col-6 mb-3">
                            <div className="card border" style={{ borderLeft: '4px solid #28a745' }}>
                              <div className="body text-center p-3">
                                <h4 className="mb-1">{stats.low || 0}</h4>
                                <small className="text-muted">Low</small>
                              </div>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Category Tabs */}
        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
             <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
              <li className="nav-item">
                <a
                  className={`nav-table-tab nav-link ${category === "all" ? "active" : ""}`}
                  onClick={() => {
                    setCategory("all");
                    setPage(1);
                    setSelectedIds([]);
                    setMultiCheckTrue(false);
                  }}
                >
                  Current
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""}`}
                  onClick={() => {
                    setCategory("risk-accepted");
                    setPage(1);
                    setSelectedIds([]);
                    setMultiCheckTrue(false);
                  }}
                >
                  Risk Accepted
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""}`}
                  onClick={() => {
                    setCategory("false-positive");
                    setPage(1);
                    setSelectedIds([]);
                    setMultiCheckTrue(false);
                  }}
                >
                  False Positive
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""}`}
                  onClick={() => {
                    setCategory("remidiated");
                    setPage(1);
                    setSelectedIds([]);
                    setMultiCheckTrue(false);
                  }}
                >
                  Remediated
                </a>
              </li>
            </ul> 
          </div>
        </div>



        {/* Vulnerabilities Table */}
        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
            <div className="card card_tableBox">
              {/* Filters */}
              <div className="header">
                <div className="body">
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <select
                        className="form-control form-control-sm"
                        value={severity}
                        onChange={(e) => {
                          setSeverity(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value="">All Severities</option>
                        <option value="critical">Critical</option>
                        <option value="high">High</option>
                        <option value="medium">Medium</option>
                        <option value="low">Low</option>
                        <option value="info">Info</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search vulnerabilities..."
                        value={search}
                        onChange={handleSearchChange}
                      />
                    </div>

                    {/* Snooze Actions for Multiple Selection */}
                    <div className="col-md-6 text-right">
                      {selectedIds?.length > 1 && userPermission && category === "all" && (
                        <Box sx={{ width: 160, display: 'inline-block' }}>
                          <FormControl fullWidth>
                            <Select
                              labelId="snooze-select-label"
                              id="snooze-select"
                              value={selectedValue}
                              onChange={(event) => {
                                setAction(event.target.value);
                                snooze("", event.target.value);
                              }}
                            >
                              <MenuItem value="pleaseSelect">
                                Snooze Options
                              </MenuItem>
                              <MenuItem value="riskAccepted">
                                Risk Accepted
                              </MenuItem>
                              <MenuItem value="markAsFalsePositive">
                                False Positive
                              </MenuItem>
                              <MenuItem value="markAsRemidiated">
                                Remediated
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      )}
                      {selectedIds?.length > 1 && (category === "false-positive" || category === "risk-accepted") && userPermission && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => unsnooze(selectedIds)}
                        >
                          Unsnooze
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-custom table-hover spacing5 mb-0">
                      <thead>
                        <tr>
                          {userPermission && (category === "all" || category === "false-positive" || category === "risk-accepted") && (
                            <th style={{ width: 40 }}>
                              <input
                                type="checkbox"
                                checked={vulnerabilities.length > 0 && vulnerabilities.every(vuln => selectedIds.includes(vuln?._id))}
                                onChange={() => multicheck(vulnerabilities)}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                          <th>Name</th>
                          <th>CVE ID</th>
                          <th>Severity</th>
                          <th>Description</th>
                          <th>Details</th>
                          {userPermission && (category === "all" || category === "false-positive" || category === "risk-accepted") && (
                            <th>Action</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {vulnerabilities.length === 0 ? (
                          <tr>
                            <td colSpan={userPermission ? "7" : "6"} className="text-center">
                              {loading ? "Loading..." : "No vulnerabilities found"}
                            </td>
                          </tr>
                        ) : (
                          vulnerabilities.map((vuln, index) => (
                            <tr key={index}>
                              {userPermission && (category === "all" || category === "false-positive" || category === "risk-accepted") && (
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedIds?.includes(vuln?._id)}
                                    onChange={() => singleClick(vuln?._id)}
                                    className="checkUncheck"
                                  />
                                </td>
                              )}
                              <td>
                                <div
                                  style={{
                                    maxWidth: "300px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer"
                                  }}
                                  data-tip={vuln.name || "N/A"}
                                  data-place="top"
                                  data-effect="solid"
                                  onClick={() => {
                                    setSelectedVuln({ ...vuln, showFullText: true });
                                    setModal("Form Wizard modal");
                                  }}
                                >
                                  {vuln.name || "N/A"}
                                  <small className="text-primary ml-1">
                                    <i className="fa fa-external-link"></i>
                                  </small>
                                </div>
                              </td>
                              <td>
                                <div style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {vuln.cveId || "N/A"}
                                </div>
                              </td>
                              <td>
                                {vuln.severity?.toLowerCase() === "critical" && (
                                  <span className="badge bg-danger" style={{ color: "white", padding: "5px 8px" }}>Critical</span>
                                )}
                                {vuln.severity?.toLowerCase() === "high" && (
                                  <span className="badge bg-warning" style={{ color: "black", padding: "5px 8px" }}>High</span>
                                )}
                                {vuln.severity?.toLowerCase() === "medium" && (
                                  <span className="badge bg-warning" style={{ color: "black", padding: "5px 8px" }}>Medium</span>
                                )}
                                {vuln.severity?.toLowerCase() === "low" && (
                                  <span className="badge bg-success" style={{ color: "white", padding: "5px 8px" }}>Low</span>
                                )}
                                {vuln.severity?.toLowerCase() === "info" && (
                                  <span className="badge bg-secondary" style={{ color: "white", padding: "5px 8px" }}>Info</span>
                                )}
                              </td>
                              <td>
                                <div
                                  style={{
                                    maxWidth: "400px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer"
                                  }}
                                  data-tip={vuln.description || "N/A"}
                                  data-place="top"
                                  data-effect="solid"
                                  onClick={() => {
                                    setSelectedVuln({ ...vuln, showFullText: true });
                                    setModal("Form Wizard modal");
                                  }}
                                >
                                  {vuln.description || "N/A"}
                                  <small className="text-primary ml-1">
                                    <i className="fa fa-external-link"></i>
                                  </small>
                                </div>
                              </td>
                              <td>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => editModal(vuln)}
                                  data-toggle="tooltip"
                                  title="View complete vulnerability details"
                                >
                                  <i className="fa fa-search-plus"></i> Details
                                </button>
                              </td>
                              {userPermission && (
                                <>
                                  {category === "all" && (
                                    <td>
                                      <Box sx={{ width: 160 }}>
                                        <FormControl fullWidth>
                                          <Select
                                            labelId="single-snooze-select-label"
                                            id="single-snooze-select"
                                            value={selectedValue}
                                            onChange={(event) => {
                                              setAction(event.target.value);
                                              snooze(
                                                vuln?._id,
                                                event.target.value,
                                                vuln?.name
                                              );
                                            }}
                                          >
                                            <MenuItem value="pleaseSelect">
                                              Snooze Options
                                            </MenuItem>
                                            <MenuItem value="riskAccepted">
                                              Risk Accepted
                                            </MenuItem>
                                            <MenuItem value="markAsFalsePositive">
                                              False Positive
                                            </MenuItem>
                                            <MenuItem value="markAsRemidiated">
                                              Remediated
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    </td>
                                  )}
                                  {(category === "risk-accepted" || category === "false-positive") && (
                                    <td>
                                      <button
                                        className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                        onClick={() => unsnooze([vuln?._id])}
                                      >
                                        Unsnooze
                                      </button>
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between align-content-center mt-3">
                    <div className="dataTables_paginate">
                      {totalItems > 0 && (
                        <Pagination
                          className="pagination-bar"
                          currentPage={page}
                          totalCount={totalItems}
                          pageSize={limit}
                          onPageChange={(newPage) => setPage(newPage)}
                        />
                      )}
                    </div>
                    {totalItems > 0 && (
                      <select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className="form-control limitSelectBox"
                      >
                        <option value={10}>10 per page</option>
                        <option value={25}>25 per page</option>
                        <option value={50}>50 per page</option>
                        <option value={100}>100 per page</option>
                      </select>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Vulnerability Details Modal */}
        <div className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""}`}>
          <div className="modal-dialog modal-xl" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Vulnerability Details: {selectedVuln.name || ""}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setModal("")}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  {selectedVuln && (
                    <div className="card">
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12 mb-3">
                            <div className="alert alert-warning">
                              <strong>Security Advisory:</strong> This vulnerability affects the system at {ip} and requires attention.
                            </div>
                          </div>

                          {/* Vulnerability Information */}
                          <div className="col-lg-6 col-md-6">
                            <div className="card border-0">
                              <div className="header bg-light pb-0">
                                <h5>Vulnerability Information</h5>
                              </div>
                              <div className="body pt-0">
                                <table className="table table-bordered table-striped mb-0">
                                  <tbody>
                                    <tr>
                                      <td width="150" className="font-weight-bold">Name</td>
                                      <td>
                                        {selectedVuln.showFullText ? (
                                          <div style={{ whiteSpace: "pre-wrap" }}>{selectedVuln.name || "N/A"}</div>
                                        ) : (
                                          selectedVuln.name || "N/A"
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="font-weight-bold">CVE ID</td>
                                      <td>{selectedVuln.cveId || "N/A"}</td>
                                    </tr>
                                    <tr>
                                      <td className="font-weight-bold">Type</td>
                                      <td>{selectedVuln.type || "N/A"}</td>
                                    </tr>
                                    <tr>
                                      <td className="font-weight-bold">Severity</td>
                                      <td>
                                        {selectedVuln.severity?.toLowerCase() === "critical" && <span className="badge bg-danger" style={{ fontSize: "14px", padding: "5px 10px", color: "white" }}>Critical</span>}
                                        {selectedVuln.severity?.toLowerCase() === "high" && <span className="badge bg-warning" style={{ fontSize: "14px", padding: "5px 10px", color: "black" }}>High</span>}
                                        {selectedVuln.severity?.toLowerCase() === "medium" && <span className="badge bg-warning" style={{ fontSize: "14px", padding: "5px 10px", color: "black" }}>Medium</span>}
                                        {selectedVuln.severity?.toLowerCase() === "low" && <span className="badge bg-success" style={{ fontSize: "14px", padding: "5px 10px", color: "white" }}>Low</span>}
                                        {selectedVuln.severity?.toLowerCase() === "info" && <span className="badge bg-secondary" style={{ fontSize: "14px", padding: "5px 10px", color: "white" }}>Info</span>}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="font-weight-bold">Source</td>
                                      <td>{selectedVuln.source || "N/A"}</td>
                                    </tr>
                                    <tr>
                                      <td className="font-weight-bold">Template ID</td>
                                      <td>{selectedVuln["template-id"] || "N/A"}</td>
                                    </tr>
                                    <tr>
                                      <td className="font-weight-bold">Severity Weight</td>
                                      <td>{selectedVuln.info?.severityWeight || "N/A"}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* Description */}
                          <div className="col-lg-12 col-md-12 mt-3">
                            <div className="card border-0">
                              <div className="header bg-light pb-0">
                                <h5>Description</h5>
                              </div>
                              <div className="body pt-0">
                                <div className="p-3 bg-light" style={{ whiteSpace: "pre-wrap", maxHeight: "300px", overflow: "auto" }}>
                                  <p>{selectedVuln.description || selectedVuln.info?.description || "No detailed description available."}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={() => setModal("")}>Close</button>
              </div>
            </div>
          </div>
        </div>

        {/* Modal for Snooze Action Details */}
        <div
          className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""}`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action === "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalTwo("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submitSnooze}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModalTwo("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetsBasedRisk;
